<template>
    <div id="ssoLogin">
        <div class="loginTitle">
            <span v-on:click="loginTab(1)" class="passLogin">{{leftLogin}}</span>
            <span v-on:click="loginTab(2)" class="quickLogin">{{rightLogin}}</span>
        </div>
        <div class="loginWin" >
            <div v-if="loginTabNum == 1">
                <!-- 用户名 -->
                <input class="loginInput longInput" type="text" v-model="userName" maxlength="40"
                       placeholder="用户名/手机号/邮箱" v-on:blur="checkUserName">
                <p class="errTip" v-if="nameErr">{{nameErrTip}}</p>
                <!-- 密码 -->
                <div class="passBox">
                    <input class="loginInput longInput" type="password" maxlength="16" v-model="password"
                           placeholder="密码"
                           v-if="passType" v-on:blur="checkPassword">
                    <input class="loginInput longInput" type="text" v-model="password" maxlength="16" placeholder="密码"
                           v-if="!passType" v-on:blur="checkPassword">
                    <img class="passEye" src="./images/open.png" alt="" v-if="passType" v-on:click="changePassType">
                    <img class="passEye" src="./images/close.png" alt="" v-if="!passType" v-on:click="changePassType">
                </div>
                <p class="errTip" v-if="passErr">{{passErrTip}}</p>

                <!-- 图片验证码 4位 -->
                <input class="loginInput midInput" type="text" v-model="imgCode" placeholder="验证码" maxlength="4"
                       v-on:blur="checkCode">
                <img class="codeImg" v-bind:src="imgSrc" alt="" v-on:click="changImgSrc">
                <p class="errTip" v-if="imgCodeErr">{{imgCodeErrTip}}</p>
                <p class="errTip msgErrTip" v-if="msgErr">{{msgErrTip}}</p>
                <div class="confirmBtn">
                    <input class="longInput confirm" type="button" value="登录" v-on:click="passLogin"
                           v-bind:disabled="noLogin">
                    <img src="./images/loading.gif" v-if="showLoading">
                </div>
            </div>
            <div v-else>
                <!-- 手机号 -->
                <input class="loginInput longInput" type="text" v-model="phone" maxlength="11" placeholder="手机号"
                       v-on:blur="checkFastPhone">
                <p class="errTip" v-if="phoneErr">{{phoneErrTip}}</p>
                <!-- 短信验证码 6位 -->
                <input class="loginInput midInput" type="text" v-model="phoneCode" placeholder="短信验证码"
                       v-on:blur="checkPhoneCode" maxlength="6">
                <input type="button" class="codeImg getPhoneCode" v-bind:value="codeTime" v-on:click="getPhoneCode" v-on:blur="clearTips" v-bind:disabled="noSend">
                <p class="errTip" v-if="phoneCodeErr">{{phoneCodeErrTip}}</p>
                <!-- 短信登录按钮 -->
                <p class="errTip msgErrTip" v-if="msgErr">{{msgErrTip}}</p>
                <div class="confirmBtn">
                    <input class="longInput confirm" type="button" value="登录" v-on:click="phoneLogin" v-bind:disabled="noLogin">
                    <img src="./images/loading.gif" v-if="showLoading">
                </div>
            </div>
             <!-- 密码登录按钮 -->
            <div class="loginBottom">
                <router-link to="/findPassword">忘记密码？</router-link>
            </div>
            <div class="loginRegister">
                <span>还没有帐号？&nbsp;&nbsp;&nbsp;&nbsp;</span><router-link to="/register" class="toRegister">立即注册</router-link>
            </div>

        </div>
        <popup :title="dialogTitle" v-if="showDialog" :showClose="showClose" :showPopBtn="showPopBtn">

        </popup>
    </div>
</template>
<script>
    import api from 'sso.server';
    import reg from 'reg';
    import aes from 'AES';
    import Popup from 'popup';

    module.exports = Vue.component('sso-login',{
        data:function() {
            return {
                loginTabNum:1,          // 密码登录或快速登录切换
                passType:true,          // 密码类型切换
                userName:'',            // 用户名
                nameErr:false,          // 用户名错误
                nameErrTip:null,

                password:'',            // 密码
                passErr:false,          // 密码错误
                passErrTip:null,

                imgCode:'',             // 验证码
                imgCodeErr:false,       // 验证码错误
                imgCodeErrTip:null,
                imgSrc:window.PAGE_DATA.commonData.basePath + window.PAGE_DATA.commonData.imgSrc, // 验证码图片地址

                phone:'',               // 手机号
                phoneCode:'',           // 短信验证码
                phoneErr:false,         // 手机号错误
                phoneErrTip:null,
                phoneCodeErr:false,
                phoneCodeErrTip:null,   // 短信验证码

                codeTime:'发送验证码',  // 获取验证码按钮文本

                msgErr:false,           // 后台错误提示
                msgErrTip:null,
                noSend:false,           // 禁止发送验证
                noLogin:false,           // 发送请求的时候,不让重复点击

                leftLogin:"密码登录",    // 左边显示的文本
                rightLogin:"快速登录",    // 右边显示的文本

                dialogTitle:"登录成功",   // 登录成功时的提示文本内容
                showDialog:false,        // 注册之后提示窗口
                showPopBtn:false,
                showClose:false,
                checkPhoneFast:false,    // 快速登录的时候电话号码是否正确
                fastPhoneCode:false,     // 快速登录验证码格式是否正确

                url:"", //
                appKey:"",
                showLoading:false        // loading图片是否显示
            }  
        },
        methods:{
            // 密码登录和快速登录切换
            loginTab:function(){
                if (this.leftLogin == "密码登录") {
                    this.leftLogin = "快速登录";
                    this.rightLogin = "密码登录";
                    this.loginTabNum = 2;
                } else {
                    this.leftLogin = "密码登录";
                    this.rightLogin = "快速登录";
                    this.loginTabNum = 1;
                }
                this.clearTips();
                this.userName = "";
                this.password = "";
                this.phone = "";
                this.phoneCode = "";
            },
            // 检测用户名,失去焦点时不能为空
            checkUserName:function(){
                if (this.userName.length == 0) {
                    this.nameErr = true;
                    this.nameErrTip = "用户名不能为空";
                } else {
                    this.nameErr = false;
                    this.nameErrTip = "";
                }
                this.msgErr = false;
            },
            // 密码失去焦点的时候,判断一下是否为空,格式是否符合
            checkPassword:function(){
                if (this.password.length == 0) {
                    this.passErr = true;
                    this.passErrTip = "密码不能为空";
                } else if (!reg.validPassword(this.password)) {
                    this.passErr = true;
                    this.passErrTip = "密码格式错误";
                } else {
                    this.passErr = false;
                    this.passErrTip = "";
                }
                this.msgErr = false;
            },
            // 验证码失去焦点的时候,是否符合规范
            checkCode:function(){
                if (this.imgCode.length == 0) {
                    this.imgCodeErr = true;
                    this.imgCodeErrTip = "验证码不能为空";
                } else if (!reg.validVerificationCode(this.imgCode)) {
                    this.imgCodeErr = true;
                    this.imgCodeErrTip = "验证码格式不正确";
                } else {
                    this.imgCodeErr = false;
                    this.imgCodeErrTip = "";
                }
                this.msgErr = false;
            },
            // 快读登录时,验证码失去焦点的时候对验证码进行简单的校验
            checkPhoneCode:function(){
                if (this.phoneCode.length == 0) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码不能为空";
                    this.fastPhoneCode = false;
                } else if (!reg.phoneCode(this.phoneCode)) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码格式不正确";
                    this.fastPhoneCode = false;
                } else {
                    this.phoneCodeErr = false;
                    this.phoneCodeErrTip = "";
                    this.fastPhoneCode = true;
                }
                this.msgErr = false;
            },
            // 密码显示隐藏切换
            changePassType:function(){
                this.passType = !this.passType;
            },
            // 更新图片验证码
            changImgSrc:function(){
                this.imgSrc = null;
                this.imgSrc = window.PAGE_DATA.commonData.basePath + window.PAGE_DATA.commonData.imgSrc + "?" + new
                Date().getTime();
            },
            // 快速登录的时候检测手机号
            checkFastPhone:function(){
                if (this.phone.length == 0) {
                    this.phoneErr = true;
                    this.phoneErrTip = "手机号不能为空";
                } else if(!reg.validPhone(this.phone)){
                    this.phoneErr = true;
                    this.phoneErrTip = '手机号不符合规范';
                } else {
                    let _this = this;
                    let getPhone = {
                        phone: this.phone
                    }
                    api.checkPhoneFast(getPhone)
                    .then(function(res){
                        if(res.data.header && (res.data.header.code == 200)){
                            _this.checkPhoneFast = true;
                            _this.phoneErr = false;
                            _this.phoneErrTip = "";
                        }else{
                            _this.phoneErr = true;
                            _this.phoneErrTip = res.data.header.msg;
                            _this.checkPhoneFast = false;
                        }
                    },function(res){
                        _this.phoneErr = true;
                        _this.phoneErrTip = "网络异常";
                        _this.checkPhoneFast = false;
                    })
                }
            },
            // 密码登录
            passLogin:function(){
                if(this.userName.length == 0){
                    this.nameErr = true;
                    this.nameErrTip = '用户名不能为空';
                    this.msgErr = false;
                }else if(this.password.length == 0){
                    this.passErr = true;
                    this.passErrTip = '密码不能为空';
                    this.msgErr = false;
                }else if (this.passErr) {
                    this.msgErr = false;
                    return;
                } else if(this.imgCode.length == 0){
                    this.imgCodeErr = true;
                    this.imgCodeErrTip = '验证码不能为空';
                    this.msgErr = false;
                } else if(this.imgCodeErr){
                    this.msgErr = false;
                    return;
                } else {
                    let _this = this;
                    _this.clearTips();
                    _this.showLoading = true;
                    _this.noLogin = true;
                    let timer = parseInt((new Date().getTime()) / 1000);
                    this.userName = this.userName.replace(/(^\s*)|(\s*$)/g, "");
                    // aes对用户名密码加密
                    let aesUserName = aes.getAes(this.userName, timer);
                    let aesPassWord = aes.getAes(this.password, timer);
                    let param = {
                        username:aesUserName,
                        password:aesPassWord,
                        url:this.url,
                        appKey:this.appKey,
                        timer:timer,
                        valdaiteCode:this.imgCode
                    }
                    api.passLogin(param)
                    .then(function(res){
                        if ((res.data.header && (res.data.header.code == 200)) == 1) {
                            _this.showDialog = true;
                            _this.noLogin = false;
                            _this.showLoading = false;
                            setTimeout(function(){
					            _this.showDialog = false;
                               window.location.href = res.data.body.data.url;
				            }, 600);

                        } else {
                            _this.msgErr = true;
                            _this.msgErrTip = res.data.header.msg;
                            _this.imgSrc = window.PAGE_DATA.commonData.basePath + window.PAGE_DATA.commonData.imgSrc +
                        "?" + new Date().getTime();
                            _this.noLogin = false;
                            _this.showLoading = false;
                            _this.imgCode = "";
                        }
                    },function(res){
                        _this.noLogin = false;
                        _this.showLoading = false;
                        _this.msgErr = true;
                        _this.msgErrTip = res.data.header.msg;
                        _this.imgSrc = window.PAGE_DATA.commonData.basePath + window.PAGE_DATA.commonData.imgSrc +
                        "?" + new Date().getTime();
                    })
                }
            },
            // 快速登录按钮触发点击提交
            phoneLogin:function(){
                let _this = this;
                if (!this.phoneErr && !this.phoneCodeErr) {
                    if (this.phone.length == 0) {
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                        this.msgErr = false;
                    } else if (this.phoneCode.length == 0) {
                        this.phoneCodeErr = true;
                        this.phoneCodeErrTip = '手机验证码不能为空';
                        this.msgErr = false;
                    } else {
                        _this.clearTips();
                        _this.noLogin = true;
                        _this.showLoading = true;
                        let timer = parseInt((new Date().getTime()) / 1000);
                        let param = {
                            timer : timer,
                            valdaiteCode: _this.phoneCode,
                            phone:aes.getAes(_this.phone, timer),
                            url:this.url,
                            appKey:this.appKey
                        }
                        api.phoneFastLogin(param)
                        .then(function(res){
                            if ((res.data.header && (res.data.header.code == 200)) == 1) {
                                _this.showDialog = true;
                                _this.noLogin = false;
                                _this.showLoading = false;
                                setTimeout(function(){
                                    _this.showDialog = false;
                                   window.location.href = res.data.body.data.url;
                                }, 600);

                            } else {
                                _this.noLogin = false;
                                _this.showLoading = false;
                                _this.msgErr = true;
                                _this.msgErrTip = res.data.header.msg;
                                _this.phoneCode = "";
                            }
                        }, function(res){
                            _this.noLogin = false;
                            _this.showLoading = false;
                            _this.msgErr = true;
                            _this.msgErrTip = res.data.header.msg;
                        })
                    }
                }
            },
            webPhoneCheck:function(){
                let state;
                if(this.phone.length == 0){
                    this.phoneErr = true;
                    this.phoneErrTip = '手机号不能为空';
                    state = false;
                }else if(!reg.validPhone(this.phone)){
                    this.phoneErr = true;
                    this.phoneErrTip = '手机号格式不正确';
                    state = false;
                }else{
                    state = true;
                }
                return state;
            },
            checkPhone:function(phone){
                let state = this.webPhoneCheck();
                if(!state){
                   return;
                }else{
                    let def = $.Deferred();
                    let _this = this;
                    this.noSend = true;             // 验证手机号期间禁止重复验证
                    api.checkPhone(phone)
                    .then(function(res){
                        if((res.header&&res.header.code)==1){
                            def.resolve({
                                res:res.header.msg,
                            });
                        }else{
                            _this.noSend = true;     // 手机号不可用，放开获取验证码按钮
                            def.reject({             // 返回不可用原因
                                res:res.header.msg,
                            });
                        }
                    },function(res){
                        _this.noSend = true;         // 手机号验证请求失败，放开获取验证码按钮
                        def.reject({
                            res:'网络异常',
                        });
                    })
                    return def.promise();
                }
            },
            // 获取短信验证码
            getPhoneCode:function(){
                let _this = this;
                if(_this.checkPhoneFast){
                    _this.noSend = true;
                    let param = {
                        phone:_this.phone
                    }
                    api.getPhoneCodeFastLogin(param)
                    .then(function(res){
                        if ((res.data.header && (res.data.header.code == 200)) == 1) {
                            _this.codeTime = 60;
                            _this.noSend = true;
                            _this.phoneCodeErrTip = "";
                            let timer = setInterval(function(){
                                if(_this.codeTime != 0){
                                    _this.codeTime--;
                                }else{
                                    clearInterval(timer);
                                    _this.codeTime = '重新发送';
                                    _this.noSend = false;       // 倒计时结束，放开获取验证码按钮
                                }
                            },1000)
                        } else {
                            _this.noSend = false;
                            _this.phoneCodeErr = true;
                            _this.phoneCodeErrTip = res.data.header.msg;
                        }
                    },function(res){
                        _this.noSend = false;
                        _this.phoneCodeErr = true;
                        _this.phoneCodeErrTip = "网络错误";
                    })
                }
            },
            clearTips:function(){
                this.nameErr = false;
                this.phoneErr = false;
                this.phoneCodeErr = false;
                this.msgErr = false;
                this.passErr = false;
            }
        },
        mounted:function(){
            let firstSplit = location.href.split("?")[1];
            if (firstSplit !== undefined) {
                let secSplit = firstSplit.split("#")[0];
                let arr = secSplit.split("&");
                this.appKey = arr[0].split("=")[1];
                this.url = arr[1].split("=")[1];
            }
            let _this = this;
            window.onkeyup = function(item){
                if (item.keyCode == 13) {
                    if (_this.loginTabNum == 1) {
                        _this.passLogin();
                    } else {
                        _this.phoneLogin();
                    }
                }
            }
        }
     
    })  
</script>
<style lang="scss" scoped>
    #ssoLogin{
        width:100%;
        .loginTitle{
            height:30px;
            margin: 0 auto;
            margin-top: 18px;
            margin-bottom: 7px;
            width: 284px;
            span{
                display:inline-block;
                height:30px;
                font-size:16px;
                color:#fff;
                line-height:30px;
                cursor:pointer;
                float:left;
                &.passLogin{
                    padding-right:10px;
                    color:#364983;
                    font-size: 22px;
                }
                &.quickLogin{
                    float: right;
                    color: #666666;
                    font-size: 16px;
                    &:hover{
                        color:#364983;
                    }
                }
            }
        }
        .loginWin{
            width: 284px;
            margin: 0 auto;
            .loginInput{
                height:42px;
                background-color: #fff;
                border:none;
                border-radius:6px;
                padding-left:10px;
                font-size:16px;
                padding: 10px 8px;
                color:#666;
                margin-top:12px;
                margin-bottom: 7px;
            }
            .longInput{
                width: 280px;
            }
            .midInput{
                width:180px;
            }
            .passBox{
                position:relative;
                .passEye{
                    position:absolute;
                    width: 17px;
                    height: 17px;
                    right:22px;
                    top: 24.5px;
                    cursor:pointer;
                }
            }
            .codeImg{
                width:90px;
                height:42px;
                float:right;
                margin-top:12px;
                border-radius:6px;
                cursor:pointer;
                &.getPhoneCode{
                    display:inline-block;
                    border:none;
                    background-color: #364983;
                    font-size:12px;
                    color:#fff;
                    text-align:center;
                    line-height:42px;
                }
            }
            .confirmBtn{
                position: relative;
                .confirm{
                    background-color: #364983;
                    color:#fff;
                    font-size:18px;
                    cursor:pointer;
                    margin-top:12px;
                    border-radius: 6px;
                    line-height: 42px;
                    border: 0px;
                    &:hover{
                        background: #435898;
                    }
                }
                img{
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    left: 100px;
                    top:24px;
                    background: 0;
                }
            }

            .errTip{
                font-size:12px;
                line-height:18px;
                color:#CE2E2E;
                padding-left:10px;
                &.msgErrTip{
                    line-height:22px;
                }
            }
            .loginBottom{
                height:18px;
                margin-top:9px;
                cursor:pointer;
                a{
                    font-size:14px;
                    color:#666666;
                    line-height:20px;
                    float:right;
                    &:hover{
                        color:#364983;
                    }
                }
            }
            .loginRegister{
                margin-top: 23px;
                border-top: 1px solid #CACACA;
                text-align: center;
                padding-top: 10px;
                padding-bottom: 18px;
                span{
                    font-size: 14px;
                    color: #666666;
                }
                a{
                    color:#364983;
                    margin-top: 10px;
                    font-size: 18px;
                    &:hover{
                        color: #435898;
                    }
                }
            }
        }
        ::-webkit-input-placeholder{
            color: #bbb;
        }
        ::-moz-placeholder{
            color: #bbb;
        }
        :-ms-input-placeholder{
            color:#bbb;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/sso/components/login/login.vue